import ColorShades from './components/ColorShades';
import React, { useState, useEffect } from "react";
import InputComponent from './components/InputComponent';
import NavigationBar from './components/NavBar';
import { Analytics } from "@vercel/analytics/react";

function App() {

  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  });

  const [colors, setColors] = useState([]);

  const addNewColor = (newColor) => {
    setColors([...colors, newColor]);

  };
  
  const removeColor = (indexToRemove) => {
    setColors(colors.filter((color, index) => index !== indexToRemove));
  };

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <Analytics/>
      <NavigationBar/>
      <div style={{
        marginTop:"1%",
      }}>
        <InputComponent addNewColor={addNewColor}/>
      </div>
      <div style={{ 
        height: "100%", 
        width: "100%", 
        alignContent:"center", 
        marginTop:"1%", 
        marginBottom:"5%"
      }}>
        {colors.map((color, index)=>(
          <div key={index}>
            <ColorShades color={color} interval={20} removeColor={() => removeColor(index)} />
          </div>
        ))}
      </div>
    </>
  );
}

export default App;
